/*
入力内容をinput:hidden要素にしてトレースする
特定の入力欄を複数のformで共有する用途で使用
<form>
    <div class="is-none js-inputTrace-target"></div>
</form>
<div class="js-inputTrace">入力要素</div>
*/
const inputTrace = document.querySelector('.js-inputTrace')

window.inputTraceStart = function () {
  if (!inputTrace) {
    return
  }
  const targetList = document.getElementsByClassName('js-inputTrace-target')

  let html = ''
  const inputList = inputTrace.querySelectorAll('input,textarea,select')
  for (const input of inputList) {
    if (input.type === 'checkbox' || input.type === 'radio') {
      if (!input.checked) {
        continue
      }
    }
    html += `<input type="hidden" name="${input.name}" value="${input.value}">`
  }

  // console.log(html)

  for (const target of targetList) {
    target.innerHTML = html
  }
}

if (inputTrace) {
  window.addEventListener('change', function (e) {
    const item = e.target.closest('.js-inputTrace input')
    if (!item) {
      return
    }
    window.inputTraceStart()
  })
  window.inputTraceStart()
}
